import React from "react";
import "./Component_5.css"
import { Container } from "react-bootstrap";

const Component_5 = ({ title,  features = [], imgSrc }) => {
  return (
    <div className="Component_5 component-2">
      <Container>
        <h2 className="div-title">{title}</h2>
      
        <ul className="feature_list">
          {features.map((item, index) => (
            <li key={index} className="feature_item">
              {item}
            </li>
          ))}
        </ul>
      </Container>
    </div>
  );
};

export default Component_5;
